// extracted by mini-css-extract-plugin
export default {"sideBar":"sideBar_sideBar__2hJML","navigationMenuItem":"sideBar_navigationMenuItem__Y6n0d","sideBarSocials":"sideBar_sideBarSocials__ITrJA"};